module.exports = __webpack_public_path__ + "tj.svg?1793caa0c484adea27824ce612e96dfc";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/tj.svg
// module id = 1647
// module chunks = 0